
      import API from "!../../../../../../../../style-loader-virtual-bb2ac0bf6a/2/yarn/cache/style-loader-npm-3.3.3-2e8bbeeac4-6c13d5075b.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../../style-loader-virtual-bb2ac0bf6a/2/yarn/cache/style-loader-npm-3.3.3-2e8bbeeac4-6c13d5075b.zip/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../../../style-loader-virtual-bb2ac0bf6a/2/yarn/cache/style-loader-npm-3.3.3-2e8bbeeac4-6c13d5075b.zip/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../../../style-loader-virtual-bb2ac0bf6a/2/yarn/cache/style-loader-npm-3.3.3-2e8bbeeac4-6c13d5075b.zip/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../../../style-loader-virtual-bb2ac0bf6a/2/yarn/cache/style-loader-npm-3.3.3-2e8bbeeac4-6c13d5075b.zip/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../../../style-loader-virtual-bb2ac0bf6a/2/yarn/cache/style-loader-npm-3.3.3-2e8bbeeac4-6c13d5075b.zip/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../../../css-loader-virtual-c45ab14dec/2/yarn/cache/css-loader-npm-6.8.1-30d84b4cf1-f20bb2a181.zip/node_modules/css-loader/dist/cjs.js!./skeleton.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../../css-loader-virtual-c45ab14dec/2/yarn/cache/css-loader-npm-6.8.1-30d84b4cf1-f20bb2a181.zip/node_modules/css-loader/dist/cjs.js!./skeleton.css";
       export default content && content.locals ? content.locals : undefined;
